import {colorSchemeDark, GridOptions, RowSelectionOptions, themeBalham} from "ag-grid-community";
import {CustomCellRendererProps} from "ag-grid-react";
import {EmailHeader} from "../services/messages/EmailHeaderDto";
import {RelativeDateTime} from "../components/common/RelativeDateTime";
import React from "react";

// noinspection UnnecessaryLocalVariableJS
export const gridTheme = themeBalham;
export const gridThemeDark = gridTheme.withPart(colorSchemeDark);

export const DefaultGridOptions: GridOptions = {
    defaultColDef: {
        resizable: false,
        sortable: false,
    },
    selectionColumnDef: {
        width: 25,
    },
    suppressCellFocus: true,
    groupDisplayType: "groupRows",
    suppressDragLeaveHidesColumns: true,
    suppressAggFuncInHeader: true,
    groupRowRendererParams: {
        suppressCount: true,
    },
};

export const DefaultSingleRowSelection: RowSelectionOptions= {
    mode: "singleRow",
    enableClickSelection: true,
    checkboxes: false,
};

export const DefaultMultiRowSelection: RowSelectionOptions= {
    mode: "multiRow",
    selectAll: "filtered",
    enableClickSelection: true,
};

export const RelativeDateTimeRenderer = ({value}: CustomCellRendererProps<EmailHeader>) => {
    return <RelativeDateTime dateTime={value} showPrefix={false}/>;
}
